module.exports = __webpack_public_path__ + "img/foto condell 3_thumb.68aafec0.jpg";